import React from 'react';

function Banner() {
  return (
    <section className="banner-section">
      <div className="banner-content">
        <div className="banner-logo-container">
          <img src="/images/logo.jpg" alt="Sloomweep Records" className="banner-logo" />
        </div>
        <h1 className="banner-title">SLOOMWEEP</h1>
        <p className="banner-subtitle">Heavy sounds from the depths</p>
      </div>
      <img src="/images/banner.jpg" alt="Sloomweep Records Banner" className="banner-image" />
    </section>
  );
}

export default Banner;

